import '@mantine/core/styles.css';
import { type ComponentType, useEffect, useState } from 'react';

import { setApiDefaults } from '../App';

// Import both views eagerly (outside React.lazy/Suspense): a lazy component
// always suspends on its first render, and React's Suspense commit-delay
// heuristic can then hold that first commit - and every effect beneath it,
// including locale and layout loading - back by several hundred ms, even
// though the underlying chunk is already cached by the time it's needed.
const desktopViewPromise = import('./DesktopAppView').then((m) => m.default);

// Main App
export default function MainView() {
  const [DesktopView, setDesktopView] = useState<ComponentType | null>(null);

  // Set initial login status
  useEffect(() => {
    try {
      // Local state initialization
      setApiDefaults();
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    desktopViewPromise.then((Component) => setDesktopView(() => Component));
  }, []);

  const View = DesktopView;

  if (!View) {
    return (
      <div style={{ alignItems: 'center', background: '#061b2c', display: 'flex', height: '100vh', justifyContent: 'center' }}>
        <img src={new URL('../assets/img/opstrack-splash.png', import.meta.url).href} alt='OpsTrack' style={{ maxWidth: '360px', width: '80%' }} />
      </div>
    );
  }

  return <View />;
}
